import { render, staticRenderFns } from "./BidPriceOfferColumnContent.vue?vue&type=template&id=0b33029e"
import script from "./BidPriceOfferColumnContent.vue?vue&type=script&lang=js"
export * from "./BidPriceOfferColumnContent.vue?vue&type=script&lang=js"
import style0 from "./BidPriceOfferColumnContent.vue?vue&type=style&index=0&id=0b33029e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports